import { MarketScheduleURL } from '../constants';
export function GetMarketSchedule(api) {
  return function () {
    return api.get(MarketScheduleURL, {});
  };
}